import Breadcrumb from "components/shared/breadcrumb";
import { memo, useState, useContext, useEffect, useCallback } from "react";
import { CSSTransition } from "react-transition-group";
import FormGenerator from "components/form-generator/main/main";
import EnumsContext from "context/initialize-context";
import { useSelector } from "react-redux";
import MasterAPI from "service/master";
import Skeleton from "components/skeleton/form";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchInfo } from "redux/slices/main";

const Profile = () => {
    const enumsData = useContext(EnumsContext);
    const dispatch = useDispatch();

    const [fields, setFields] = useState([]);
    const [goSubmit, setGoSubmit] = useState(0);
    const [loading, setLoading] = useState(false);
    const [defaultValues, setDefaultValues] = useState({});
    const [dataIsDraft, setDataIsDraft] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(true);

    const info = useSelector(state => state.main.info);
    const isSignup = Object.keys(info.shop).length === 0;

    useEffect(() => {
        const newFields = [];
        enumsData.data.formElements.forEach(field => {
            if (field.form_id === 11) {
                newFields.push({
                    ...field,
                    name: `e${field.id}_${field.name}`
                });
            }
        });

        setFields(newFields);
        // eslint-disable-next-line
    }, [enumsData])

    useEffect(() => {
        defaultValuesFetcher();
        // eslint-disable-next-line
    }, [])

    const defaultValuesFetcher = async () => {
        if (!isSignup) {
            try {
                const defaultValuesRes = await MasterAPI({
                    method: "GET",
                    url: "/api/profile/get"
                });

                if (defaultValuesRes.draft) {
                    setDefaultValues(defaultValuesRes.draft.content.fields);
                    setDataIsDraft(true);
                } else
                    setDefaultValues(defaultValuesRes.data.fields);

                setShowSkeleton(false);
            } catch {
                toast.error("خطا در دریافت اطلاعات قبلی");
                setShowSkeleton(false);
            }
        } else
            setShowSkeleton(false);
    }

    const submitHandler = () => {
        setGoSubmit(prev => prev + 1);
    }

    const setParentLoading = useCallback(value => {
        setLoading(value);
        // eslint-disable-next-line
    }, [])

    const reloadData = useCallback(() => {
        defaultValuesFetcher();
        // eslint-disable-next-line
    }, [])

    const doneCallback = useCallback(() => {
        dispatch(fetchInfo());
        // eslint-disable-next-line
    }, [])

    return (
        <div className="m-container">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">اطلاعات فروشگاه</h1>
                    <Breadcrumb data={[
                        { title: "اطلاعات فروشگاه" }
                    ]} />
                </div>

                <div className="flex">
                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center" onClick={reloadData} title="بروزرسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-7 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${loading ? " cursor-progress" : ""}`}
                        onClick={submitHandler}
                    >
                        <i className="fa-light fa-file ml-2"></i>
                        ثبت اطلاعات

                        <CSSTransition in={loading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !showSkeleton ? (
                        <FormGenerator
                            fields={fields}
                            submitUrl={isSignup ? "/api/profile/create" : "/api/profile/edit"}
                            goSubmit={goSubmit}
                            setParentLoading={setParentLoading}
                            payloadType={3}
                            defaultValues={defaultValues}
                            submitMethod={isSignup ? "POST" : "PUT"}
                            preData={{ form_id: 11 }}
                            draftLabel={dataIsDraft}
                            doneCallback={doneCallback}
                        />
                    ) : <Skeleton />
                }
            </div>
        </div>
    )
}

export default memo(Profile);